<template>
  <div>
    <MasterSitePublisher />
    <SitePublisher />
  </div>
</template>

<script>
import MasterSitePublisher from './MasterSitePublisher'
import SitePublisher from './SitePublisher'

export default {
  name: 'SessionShareContainer',
  components: {
    MasterSitePublisher,
    SitePublisher
  }
}
</script>
